import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import './KmzDownloadNotificationBanner.scss';

/**
 * <KmzDownloadNotificationBanner> - child component of <GlobalBanner>
 */
export default class KmzDownloadNotificationBanner extends React.Component {

  constructor(props) {
    super(props);
    KmzDownloadNotificationBanner.propTypes = {
      kmzFileName: PropTypes.string.isRequired,
    };
    this.state = {
      shown: false,
    };

    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });

    this.closeBanner = this.closeBanner.bind(this);
    this.navigateToDestination = this.navigateToDestination.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 0);
  }

  /** HELPERS */
  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // clear from local storage and hide the component
        dataModel.hideGlobalBanner(this.props.bannerType, true);
      }, 150);
    });
  }

  async navigateToDestination() {
    const { kmz_type, kmz_id, attachment_id } = this.props;

    let kmzType;
    
    switch (kmz_type) {
    case 'ProjectGroup':
      kmzType = 'project_group';
      break;
    case 'Company':
      kmzType = 'company';
      break;
    default:
      kmzType = 'project';
    }

    let fileUrl = process.env.REACT_APP_API + '/kmz/' +
                  kmzType + '/' +
                  kmz_id + '/download?current_company=' + localStorage.current_company_id +
                  '&attachment_id=' + attachment_id + '&token=' + localStorage.token;

    // Function to validate URL before navigation
    const response = await fetch(fileUrl);  
    if (response.ok) {
      const link = document.createElement('a');
      link.href = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const errorMessage = 'KMZ file not found';
      dataModel.displayInfoErrorMessage(errorMessage, 4000);
    }

    this.closeBanner();
  }

  render() {
    const { kmz_type } = this.props;

    let kmzType;
    
    switch (kmz_type) {
    case 'ProjectGroup':
      kmzType = 'Project Group';
      break;
    case 'Company':
      kmzType = 'Company';
      break;
    default:
      kmzType = 'Project';
    }
    
    let bannerText = (
      <span className="kmz-download-banner__text">
        Your {`${kmzType}`} KMZ file is ready.&nbsp;
        <p onClick={this.navigateToDestination} className="kmz-download-banner__link">Click here to download.</p>
      </span>
    );    

    return (
      <span className={'kmz-download-banner' + (this.state.shown ? '' : ' kmz-download-banner--closing')}>
        { bannerText }
        <span className="kmz-download-banner__close" onClick={this.closeBanner}>&times;</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/KmzDownloadNotificationBanner/index.js